import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconLoading({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g fill={fill}>
                <rect x="8.75" y="5" width="1.5" height="4" rx=".75" transform="rotate(-180 8.75 5)"/>
                <rect x="6.646" y="5.22" width="1.5" height="4" rx=".75" transform="rotate(140 6.646 5.22)" opacity=".2"/>
                <rect x="5.176" y="6.74" width="1.5" height="4" rx=".75" transform="rotate(100 5.176 6.74)" opacity=".3"/>
                <rect x="5.027" y="8.85" width="1.5" height="4" rx=".75" transform="rotate(60 5.027 8.85)" opacity=".4"/>
                <rect x="6.269" y="10.563" width="1.5" height="4" rx=".75" transform="rotate(20 6.27 10.563)" opacity=".5"/>
                <rect x="8.321" y="11.076" width="1.5" height="4" rx=".75" transform="rotate(-20 8.321 11.076)" opacity=".6"/>
                <rect x="10.223" y="10.149" width="1.5" height="4" rx=".75" transform="rotate(-60 10.223 10.15)" opacity=".7"/>
                <rect x="11.085" y="8.218" width="1.5" height="4" rx=".75" transform="rotate(-100 11.085 8.218)" opacity=".8"/>
                <rect x="10.503" y="6.184" width="1.5" height="4" rx=".75" transform="rotate(-140 10.503 6.184)" opacity=".9"/>
            </g>
        </svg>
    );
}

export default IconLoading;
